// extracted by mini-css-extract-plugin
export var attribution = "_ci-4";
export var authorName = "_ci-5";
export var quote = "_ci-3";
export var testimonial = "_ci-2";
export var trustedBy = "_ci-0";
export var trustedByLabel = "_ci-1";